import type { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import React, { useMemo } from 'react';

import { baseChartOption } from './dashboardChartTheme';

export interface DashboardEChartProps {
  option: EChartsOption;
  height: number | string;
  className?: string;
}

const DashboardEChart: React.FC<DashboardEChartProps> = ({ option, height, className }) => {
  const merged = useMemo(
    () => ({
      ...baseChartOption(),
      ...option,
    }),
    [option],
  );

  return (
    <ReactECharts
      className={className}
      option={merged}
      style={{ height, width: '100%' }}
      opts={{ renderer: 'svg' }}
      notMerge
      lazyUpdate
    />
  );
};

export default DashboardEChart;
